import React from 'react';

export type KYCStatus = 'none' | 'pending' | 'in_progress' | 'approved' | 'rejected';

interface KYCStatusBadgeProps {
  status: KYCStatus;
  citizenStatus?: boolean;
  expirationDate?: string | Date | null;
  expired?: boolean;
  className?: string;
}

const KYCStatusBadge: React.FC<KYCStatusBadgeProps> = ({ 
  status, 
  citizenStatus, 
  expirationDate,
  expired,
  className = '' 
}) => {
  // If expired, show expired status regardless of original status
  const displayStatus = expired ? 'expired' : status;
  
  const statusConfig: Record<KYCStatus | 'expired', { label: string; color: string; bgColor: string }> = {
    none: {
      label: 'Not Started',
      color: 'text-[var(--color-neutral-700)]',
      bgColor: 'bg-[var(--color-neutral-100)]',
    },
    pending: {
      label: 'Pending Review',
      color: 'text-[var(--color-warning-700)]',
      bgColor: 'bg-[var(--color-warning-100)]',
    },
    in_progress: {
      label: 'In Progress',
      color: 'text-[var(--color-brand-700)]',
      bgColor: 'bg-[var(--color-brand-100)]',
    },
    approved: {
      label: citizenStatus ? 'Approved - Citizen' : 'Approved',
      color: 'text-[var(--color-success-700)]',
      bgColor: 'bg-[var(--color-success-100)]',
    },
    rejected: {
      label: 'Rejected',
      color: 'text-[var(--color-error-700)]',
      bgColor: 'bg-[var(--color-error-100)]',
    },
    expired: {
      label: 'Expired',
      color: 'text-[var(--color-error-700)]',
      bgColor: 'bg-[var(--color-error-100)]',
    },
  };

  const config = statusConfig[displayStatus] || statusConfig.none;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className={`px-3 py-1 rounded-full text-sm font-medium ${config.bgColor} ${config.color} ${className}`}>
        {config.label}
      </span>
      {expirationDate && !expired && (
        <span className="text-xs text-[var(--color-subtext-color)]">
          Expires: {new Date(expirationDate).toLocaleDateString()}
        </span>
      )}
    </div>
  );
};

export default KYCStatusBadge;

